import { ConfigApi, IdentityApi } from '@backstage/core-plugin-api';
import { DetailsApi } from './details-api';
import { Entity } from '@backstage/catalog-model';
import { TemplateDetails } from '../../types/details';

export class DetailsApiClient implements DetailsApi {
  private readonly configApi;
  private readonly identityApi;
  constructor(configApi: ConfigApi, identityApi: IdentityApi) {
    this.configApi = configApi;
    this.identityApi = identityApi;
  }

  async retrieveDetailsInfo(requestedEntity: Entity): Promise<TemplateDetails> {
    const { token } = await this.identityApi.getCredentials();
    const url = this.configApi.getString('backend.baseUrl');
    const response = await fetch(
      `${url}/api/metricsAlertingInsights/v1/template/details`,
      {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ entity: requestedEntity }),
      },
    );
    if (!response.ok) {
      throw new Error(
        `Failed to retrieve details info, ${response.status} ${response.statusText}`,
      );
    }
    const responseData = await response.json();
    return responseData.details as TemplateDetails;
  }
}
